export var Issuer;
(function (Issuer) {
  Issuer['Auth0'] = 'Auth0';
  Issuer['Firebase'] = 'Firebase';
  Issuer['JWT'] = 'JWT';
  Issuer['Amplify'] = 'Amplify';
})(Issuer || (Issuer = {}));
